export const formatVersion = (version: number): string => {
  const str = version.toString();
  const len = str.length;

  if (len < 3) {
    throw new Error("Input number must be at least 3 digits");
  }

  const major = str.slice(0, len - 4) || "0"; // メジャーバージョン
  const minor = str.slice(Math.max(0, len - 4), len - 2).replace(/^0+/, '') || "0"; // マイナーバージョン
  const patch = str.slice(len - 2).replace(/^0+/, '') || "0"; // 先頭の0を削除

  return `${major}.${minor}.${patch}`;
}
